import { connect } from 'react-redux';
import get from 'lodash.get';
import Select from './Select';

const mapStateToProps = ({ form }, ownProps) => {
  const currentForm = ownProps.meta.form;
  return {
    form,
    currentForm,
    isActiveField:
      ownProps.input.name === get(form[currentForm], 'active', null),
  };
};

export default connect(mapStateToProps)(Select);
